<div class="wrapper">
  <mat-table matSort matSortActive="date" matSortDirection="desc" [dataSource]="dataSource()"
    class="mat-elevation-z0 demo-table">
    @for (column of columns; track column) {
    <ng-container [matColumnDef]="column.columnDef">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ column.header }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        @if (customTemplates[column.columnDef]) {
        <ng-container *ngTemplateOutlet="customTemplates[column.columnDef]; context: { $implicit: row, column }">
        </ng-container>
        } @else {
        {{ column.cell(row) }}
        }
      </mat-cell>
    </ng-container>
    }

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>